const e = {
  MINSWAP: {
    name: "MinSwap",
    url: "https://minswap.org/",
    logo: "https://storage.googleapis.com/dexhunter-images/public/minswap.png",
    code: "MINSWAP"
  },
  SUNDAESWAP: {
    name: "SundaeSwap",
    url: "https://sundaeswap.finance/",
    logo: "https://storage.googleapis.com/dexhunter-images/public/sundae.png",
    code: "SUNDAESWAP"
  },
  SPECTRUM: {
    name: "Spectrum",
    url: "https://spectrum.cards/",
    logo: "https://storage.googleapis.com/dexhunter-images/public/spectrum.png",
    code: "SPECTRUM"
  },
  VYFI: {
    name: "VyFinance",
    url: "https://vy.finance/",
    logo: "https://storage.googleapis.com/dexhunter-images/public/vyfi.png",
    code: "VYFI"
  },
  WINGRIDER: {
    name: "Wingriders",
    url: "https://wingriders.io/",
    logo: "https://storage.googleapis.com/dexhunter-images/public/wingriders.png",
    code: "WINGRIDER"
  },
  MUESLISWAP: {
    name: "MuesliSwap",
    url: "https://muesliswap.com/",
    logo: "https://storage.googleapis.com/dexhunter-images/public/muesli.png",
    code: "MUESLISWAP"
  },
  TEDDY: {
    name: "TeddySwap",
    url: "https://teddyswap.org/",
    logo: "https://storage.googleapis.com/dexhunter-images/public/teddyswap.jpeg",
    code: "TEDDY"
  }
}, o = {
  name: "DexHunter",
  url: "https://dexhunter.io/",
  logo: "https://storage.googleapis.com/dexhunter-images/public/coin.svg",
  code: "DEXHUNTER"
};
export {
  o as DEXHUNTER_DEX_INFO,
  e as dexes
};
